document.addEventListener('DOMContentLoaded', function() {
    const insurerSelect = document.getElementById('verzekeraar');
    const packageSelect = document.getElementById('pakket');
    const nextStep1Button = document.getElementById('nextStep1');
    const prevStep2Button = document.getElementById('prevStep2');
    const showResultButton = document.getElementById('showResult');
    const resultDiv = document.getElementById('result');
    const resultText = document.getElementById('resultText');
    const step1Div = document.getElementById('step1');
    const step2Div = document.getElementById('step2');

    const jsonUrl = `/cdn/shop/t/5/assets/zorgverzekeraar_pakketten.json?v=${Date.now()}`;

    // Load and parse the JSON file
    fetch(jsonUrl)
        .then(response => response.json())
        .then(data => {
            // Create a unique list of insurers
            const insurers = [...new Set(data.map(item => item.zorgverzekeraar))];
            // Populate the insurer dropdown
            insurers.forEach(insurer => {
                const option = document.createElement('option');
                option.value = insurer;
                option.textContent = insurer;
                insurerSelect.appendChild(option);
            });

            // Go to Step 2 on next button click
            nextStep1Button.addEventListener('click', function() {
                step1Div.style.display = 'none';
                step2Div.style.display = 'block';
                showResultButton.style.display = 'block';
                resultDiv.style.display = 'none';

                const selectedInsurer = insurerSelect.value;
                // Filter packages by the selected insurer
                const packages = data.filter(item => item.zorgverzekeraar === selectedInsurer);
                packageSelect.innerHTML = ''; // Clear existing options
                packages.forEach(pkg => {
                    const option = document.createElement('option');
                    option.value = pkg.pakket_naam;
                    option.textContent = pkg.pakket_naam;
                    packageSelect.appendChild(option);
                });
            });

            // Return to Step 1 on prev button click
            prevStep2Button.addEventListener('click', function() {
                step1Div.style.display = 'block';
                step2Div.style.display = 'none';
                showResultButton.style.display = 'none';
                resultDiv.style.display = 'none';
            });

            // Show result on button click
            showResultButton.addEventListener('click', function() {
                const selectedPackage = packageSelect.value;
                const packageInfo = data.find(item => item.pakket_naam === selectedPackage);

                const messageClass = packageInfo.pakket1_vergoed !== 1 ? 'success-message' : 'error-message';
                
                // Clear previous classes
                resultText.className = '';
                // Add the determined class
                resultText.classList.add(messageClass);
                
                resultText.innerHTML = packageInfo ? `${packageInfo.pakket_vergoeding_string}<br><br>Pakket Voorwaarden: ${packageInfo.pakket_voorwaarden || 'Geen voorwaarden beschikbaar.'}` : 'No info';
                resultDiv.style.display = 'block';
                dataLayer.push({'event':'vergoedingEvent'});
            });

            // Handle package selection change
            packageSelect.addEventListener('change', function() {
                showResultButton.style.display = 'block'; // Show the result button
            });
        });
});